import React from 'react'
import { Link } from 'gatsby'
import ImLogo from '../../images/invoicemaker-logo.svg'
import * as style from './style.module.scss'

const Logo = ({ to }) => (
    <Link className={style.logo} rel="home" to={to}>
        <ImLogo />
        <span>Invoice Maker</span>
    </Link>
)

export default Logo
